import { render, staticRenderFns } from "./ListadoDescuentos.vue?vue&type=template&id=59a764c1&scoped=true"
import script from "./ListadoDescuentos.vue?vue&type=script&lang=js"
export * from "./ListadoDescuentos.vue?vue&type=script&lang=js"
import style0 from "./ListadoDescuentos.vue?vue&type=style&index=0&id=59a764c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a764c1",
  null
  
)

export default component.exports